import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import {getOrderNowButtonText} from '../../helpers/date.helper';
import {showPromotionsBox} from '../../helpers/promotions.helper';
import {getGalleryMeals} from '../../helpers/gallery.helper';
import GalleryPageContent from './GalleryPageContent';

export const GalleryPage = ({menu, restaurant}) => {
  const galleryMeals = getGalleryMeals(menu.topDishes, menu.meals);
  const orderNowButtonText = getOrderNowButtonText(restaurant.openingTimes, restaurant.modes);
  const showPromotionContent =
    restaurant.content.promotions && showPromotionsBox(restaurant.content.promotions, 'gallery');

  return GalleryPageContent({
    galleryMeals,
    orderNowButtonText,
    promotions: restaurant.content.promotions,
    showPromotionContent
  });
};

GalleryPage.propTypes = {
  language: PropTypes.string.isRequired,
  menu: PropTypes.object.isRequired,
  restaurant: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    language: state.language
  };
};

export default connect(mapStateToProps)(ContextProvider(GalleryPage));



// WEBPACK FOOTER //
// ./containers/GalleryPage/GalleryPage.js